<template>
	<section class="intro" data-url="">
		<div
			class="header-moma"
			:class="{ 'i-on': displayState === 'gallery' }"
		>
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 486.7 121.5"
				style="enable-background:new 0 0 486.7 121.5;"
				xml:space="preserve"
			>
				<g>
					<path
						fill="#FFFFFF"
						class="st0"
						d="M319.2,0h43.9v121.5h-28.8V31.1l-22.5,90.4h-26.1l-22.2-90.7v90.7h-27.2V0h45.7l18.5,76.8L319.2,0z M82.8,0
					h44.1v121.5h-29V31.1l-22.4,90.4H49.4L27.2,30.8v90.7H0V0h45.7l18.5,76.8L82.8,0z M449.4,0h-37.9l-39.4,121.5h28.7l7-22.5h42
					l6.8,22.5h30.1L449.4,0z M415.4,76.1l14.3-46.8l13.4,46.8H415.4z M181.5,36.3c-22.5,0-43.7,14.9-43.7,42.4v1.8
					c0,27.9,21.2,42.6,43.7,42.6c22.7,0,43.9-14.7,43.9-42.6v-1.8C225.4,51.2,204.1,36.3,181.5,36.3z M196.2,81.7
					c0,15.4-6.2,21.7-14.7,21.7c-8.4,0-14.6-6.3-14.6-21.7v-4.1c0-15.7,6.2-21.7,14.6-21.7c8.6,0,14.7,6,14.7,21.7V81.7z"
					/>
				</g>
			</svg>
		</div>
		<div
			class="header-intro"
			:class="{ 'i-on': displayState === 'gallery' }"
		>
			<p>
				<strong>MoMA through Time</strong> <br />An incomplete history of
				MoMA and MoMA PS1, as told through objects in the archives. Jump
				into a highlight from our timeline or start at the beginning by
				<span class="m-under">scrolling&nbsp;below</span>.
			</p>
		</div>

		<div
			class="mask-intro-panel"
			v-if="aniIntro === 'started'"
			:class="{ 'slideshow-on': displayState === 'gallery' }"
		>
			<div
				class="intro-panel-bg"
				v-for="(dp1, dp1i) in dataPreview"
				v-if="dp1i <= 8"
				v-bind:key="dp1i"
				:class="{
					'presenting': aniSection >= dp1i && aniSection < 10,
					'intro-panel-1': decadeToPos(1, dp1i),
					'intro-panel-2': decadeToPos(2, dp1i),
					'intro-panel-3': decadeToPos(3, dp1i),
					'intro-panel-4': decadeToPos(4, dp1i),
					'intro-panel-5': decadeToPos(5, dp1i),
					'intro-panel-6': decadeToPos(6, dp1i),
					'intro-panel-7': decadeToPos(7, dp1i),
					'intro-panel-8': decadeToPos(8, dp1i),
					'intro-panel-9': decadeToPos(9, dp1i),
					'intro-panel-10': decadeToPos(10, dp1i)
				}"
				v-bind:style="{
					'background-image':
						'url(\'' +
						pathToMedia +
						dataPreview[dp1i]['imgSliver'] +
						'\')'
				}"
			></div>
		</div>

		<IntroCycle
			v-if="displayState === 'gallery' && dataIntroFinal !== null"
			v-bind:choices="dataIntroFinal"
			v-bind:rootPath="rootPath"
			v-bind:headerpos="headerpos"
		></IntroCycle>
	</section>
</template>

<script>
var inView = require("in-view");
import IntroCycle from "./IntroCycle.vue";
export default {
	name: "Intro",
	data() {
		return {
			loading: false,
			dataIntro: null,
			pathToMedia: "/interactives/moma_through_time/static/uploads",
			dataPreview: [],
			dataIntroFinal: null,

			displayState: null, // null //'gallery'
			request: null,
			aniIntro: null,
			aniTimer: 0,
			aniTimerWipe: 0,
			aniSection: 0
		};
	},
	created() {
		// flag switch
		// this.pathToMedia = "http://54.87.134.1/wp-content/uploads";
		this.pathToMedia = process.env.NODE_ENV === "production"
			? "/interactives/moma_through_time/static/uploads"
			: "/static/uploads";
		this.fetchData();

		// console.log(this.bgout);
	},
	mounted() {
		let introThis = this;
		inView(".intro")
			// .on('enter', el => {
			.on("enter", function() {
				requestAnimationFrame(introThis.performAnimation);
			})
			.on("exit", function() {
				cancelAnimationFrame(introThis.request);
			});
	},
	components: {
		IntroCycle
	},
	props: ["rootPath", "apiPath", "headerpos"],
	methods: {
		decadeToPos(checkDate, passedInfo) {
			// console.log(passedInfo);
			if (
				this.dataPreview[passedInfo] &&
				this.dataPreview[passedInfo]["decade"]
			) {
				if (
					this.dataPreview[passedInfo]["decade"] === "1920" &&
					checkDate === 1
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "1930" &&
					checkDate === 2
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "1940" &&
					checkDate === 3
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "1950" &&
					checkDate === 4
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "1960" &&
					checkDate === 5
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "1970" &&
					checkDate === 6
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "1980" &&
					checkDate === 7
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "1990" &&
					checkDate === 8
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "2000" &&
					checkDate === 9
				) {
					return true;
				} else if (
					this.dataPreview[passedInfo]["decade"] === "2010" &&
					checkDate === 10
				) {
					return true;
				}
			}
			return false;
		},
		fetchData() {
			this.error = this.dataIntro = null;
			this.loading = true;
			let localThis = this;
			// flag switch point
			// let baseURI = this.apiPath + "/?get=datagen-intro&preview=1";
			let filenameActual = '_intro.js';
			// Uncomment next line for local assets
			let baseURI = this.rootPath + 'static/uploads/data/'+filenameActual+'?v=1.05';
			this.$http
				.get(baseURI)
				.then(result => {
					// this.users = result.data
					// eslint-disable-next-line
					// console.log(result.data);
					localThis.dataIntro = result.data;
					localThis.loading = false;
					localThis.init();
				})
				.catch(function(err) {
					localThis.error = err.toString();
					localThis.loading = false;
				});
		},
		init() {
			// console.log(this.dataIntro);
			this.Shuffle(this.dataIntro);
			let extras = [];
			let decadesRep = [];
			let tempFinal = [];
			for (var i = 0; i < this.dataIntro.length; i++) {
				if (decadesRep.includes(this.dataIntro[i]["decade"])) {
					extras.push(this.dataIntro[i]);
				} else {
					decadesRep.push(this.dataIntro[i]["decade"]);
					this.dataPreview.push(this.dataIntro[i]);
					tempFinal.push(this.dataIntro[i]);
				}
			}
			for (var e = 0; e < extras.length; e++) {
				tempFinal.push(extras[e]);
			}
			this.dataIntroFinal = tempFinal;
			// console.log(this.dataPreview);
			// console.log(extras);
			// for(var i = 0; i < this.bgs.length; i++){
			// 	let randBG = Math.floor(Math.random() * this.bgs[i].length);
			// 	this.bgout[i] = this.rootPath + 'static/intro/' + this.bgs[i][randBG];
			// }
		},
		Shuffle: function(o) {
			// eslint-disable-next-line
			for (
				var j, x, i = o.length;
				i;
				j = parseInt(Math.random() * i),
					x = o[--i],
					o[i] = o[j],
					o[j] = x
					// eslint-disable-next-line
			) {}
			return o;
		},
		performAnimation() {
			let scopeThis = this;
			scopeThis.request = requestAnimationFrame(
				scopeThis.performAnimation
			);
			if (scopeThis.dataIntroFinal !== null) {
				scopeThis.draw();
			}
		},
		draw() {
			if (this.aniIntro === null) {
				this.aniIntro = "started";
			}
			if (this.aniSection < 9) {
				if (this.aniTimer >= 10) {
					this.aniSection = this.aniSection + 1;
					this.aniTimer = 0;
				}
				this.aniTimer = this.aniTimer + 1;
			}
			if (this.aniSection >= 7 && this.displayState === null) {
				// this.aniTimerWipe = 0;
				// if (this.aniTimerWipe >= 30) {
				this.displayState = "gallery";
				// } else {
				// 	this.aniTimerWipe = this.aniTimerWipe + 1;
				// }
			}
		}
	}
};
</script>

<style lang="scss">
@import "../sass/_mq.scss";
@mixin visEnlarge {
	@include aboveTablet {
		transition-delay: 0.18s;
		transition-duration: 0.06s;
	}
}

@mixin headerstyle {
	font-size: 32px;
	font-weight: 600;
	@include tabletBelow {
		font-size: 20px;
	}
}
@mixin headerclassify {
	font-size: 20px;
	font-weight: 400;
	@include tabletBelow {
		font-size: 16px;
	}
}
.intro {
	position: relative;
	min-height: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background: black;
	color: white;
	align-items: center;
	justify-content: space-between;
	z-index: 10;
	&:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 250px;
		z-index: 4;
		background: -moz-linear-gradient(
			top,
			rgba(0, 0, 0, 0.5) 0%,
			rgba(0, 0, 0, 0) 100%
		); /* FF3.6-15 */
		background: -webkit-linear-gradient(
			top,
			rgba(0, 0, 0, 0.5) 0%,
			rgba(0, 0, 0, 0) 100%
		); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(
			to bottom,
			rgba(0, 0, 0, 0.5) 0%,
			rgba(0, 0, 0, 0) 100%
		); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	}
	@include tabletBelow {
		padding: 0 20px;
		display: block;
	}
}

.header-moma {
	position: absolute;
	z-index: 5;
	width: 129.985px;
	height: 32.317px;
	top: 35px;
	right: 35px;
	svg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	path {
		fill: white;
	}

	@include tabletBelow {
		position: relative;
		top: 0;
		right: auto;
		margin: 0;
		width: auto;
		height: auto;
		padding-top: 22px;
		left: 2px;
		svg {
			position: relative;
			width: 96.53px;
			height: 24px;
		}
	}
}
.header-intro {
	position: absolute;
	top: 28px;
	left: 35px;
	z-index: 5;
	margin-top: 0;
	width: 37%;
	margin-bottom: auto;
	max-width: 650px;
	text-align: left;
	transition-duration: 1s;
	transition-property: opacity;
	@media (min-width: 1230px) {
		font-size: 1.5vw;
	}
	@media (min-width: 1500px) {
		font-size: 22px;
	}
	p {
		margin: 0;
	}
	@include tabletBelow {
		position: relative;
		width: auto;
		margin: 20px 20px 0 0;
		left: 0;
		top: auto;
	}
}
.get-started {
	margin-top: auto;
	margin-bottom: 30px;
	text-align: center;
	transition-duration: 0.5s;
	@include aboveTablet {
		&.hide-help {
			opacity: 0;
		}
	}
	a {
		color: inherit;
		text-decoration: none;
	}
}
.start-here {
	margin-bottom: 20px;
	transition-duration: 1s;
	span {
		cursor: pointer;
	}
	svg {
		transform: translateY(-1px);
		path {
			fill: white;
		}
	}
}
.get-started,
.start-here {
	svg {
		width: 24px;
		height: 24px;
		display: inline-block;
		vertical-align: middle;
		margin-left: 5px;
		opacity: 0.5;
	}
	span:hover,
	a:hover {
		svg {
			opacity: 1;
		}
	}
}

.header-moma,
.header-intro {
	opacity: 0;
	transition-duration: 1s;
	transition-delay: 1.3s;
	@include tabletBelow {
		opacity: 1;
	}
	.intro-vis &,
	&.i-on {
		opacity: 1;
	}
}

.mask-intro-panel {
	&.slideshow-on {
		transition-duration: 1s;
		opacity: 0;
		transition-delay: 2s;
		pointer-events: none;
	}
}
.intro-panel-bg {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	width: 10%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 50% 50%;
	overflow: hidden;
	transition-duration: 0.15s;
	overflow: hidden;
	opacity: 0.5;
	&:before,
	&:after {
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		width: 51%;
		background: black;
		z-index: 2;
		transition-duration: 0.2s;
	}
	&:before {
		left: 0;
	}
	&:after {
		right: 0;
	}
	&.presenting {
		&:before {
			transform: translateX(-100.5%);
		}
		&:after {
			transform: translateX(100.5%);
		}
	}

	&.intro-panel-1 {
		left: 0%;
	}
	&.intro-panel-2 {
		left: 10%;
	}
	&.intro-panel-3 {
		left: 20%;
	}
	&.intro-panel-4 {
		left: 30%;
	}
	&.intro-panel-5 {
		left: 40%;
	}
	&.intro-panel-6 {
		left: 50%;
	}
	&.intro-panel-7 {
		left: 60%;
	}
	&.intro-panel-8 {
		left: 70%;
	}
	&.intro-panel-9 {
		left: 80%;
	}
	&.intro-panel-10 {
		left: 90%;
	}

	@media (max-width: 800px) {
		width: 20%;
		opacity:1;
		&.intro-panel-1 {
			left: 0%;
		}
		&.intro-panel-2 {
			left: 20%;
		}
		&.intro-panel-3 {
			left: 40%;
		}
		&.intro-panel-4 {
			left: 60%;
		}
		&.intro-panel-5 {
			left: 80%;
		}
		&.intro-panel-6 {
			left: 0%;
		}
		&.intro-panel-7 {
			left: 20%;
		}
		&.intro-panel-8 {
			left: 40%;
		}
		&.intro-panel-9 {
			left: 60%;
		}
		&.intro-panel-10 {
			left: 80%;
		}
	}
	.bgEl {
		opacity: 0;
		background-size: auto 100%;
		background-position: 50% 50%;
		// opacity:1;
	}
}

.intro-options {
	text-align: center;
}
.intro-options-timed {
	text-align: center;
	margin-top: -70px;
}
.feature-row {
	@include headerstyle;
	opacity: 0;
	.vInit .active & {
		&:nth-child(1) {
			animation: fadein 0.2s 0.2s linear forwards;
		}
		&:nth-child(2) {
			animation: fadein 0.2s 0.3s linear forwards;
		}
		&:nth-child(3) {
			animation: fadein 0.2s 0.4s linear forwards;
		}
		&:nth-child(4) {
			animation: fadein 0.2s 0.5s linear forwards;
		}
	}
	a {
		color: inherit;
		display: inline-block;
		text-decoration: none;
		border-bottom: solid 2px white;
		line-height: 1.2;
	}
}

header {
	position: sticky;
	top: 0;
	left: 0;
	width: 100%;
	backface-visibility: hidden;
	background: rgba(255, 255, 255, 0.94);
	z-index: 10;
	@include headerstyle;
	.results-filtered & {
		.decades {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;

			.filter-decade {
				width: 100%;
			}
		}
	}
	.filter-title {
		white-space: nowrap;
		padding: 6px 0 10px 30px;
		&.ps1 {
			svg {
				position: relative;
				width: 75px;
				height: 42px;
			}
		}
	}
	@include tabletBelow {
		background: white;
	}
}
header + .decade-sep {
	margin-top: 140px;
}

.ib-datewrap {
	position: relative;
	display: inline-block;
	color: white;
	cursor: pointer;
	&:after {
		content: "↓";
		position: absolute;
		left: 100%;
		top: 1px;
		margin-left: 5px;
		@include headerclassify;
		font-size: 18px;
		opacity: 0;
		transition-duration: 0.2s;
	}
	&:hover {
		&:after {
			opacity: 1;
		}
	}
}
</style>
